import * as slick from "./plugins/slick.js";
import * as mfp from "./plugins/mfp.js";
import * as lazyload from "./plugins/lazyload.js";
import * as isotope from "./plugins/isotope.js";
import * as tippy from "./plugins/tippy.js";
//import * as masonry from "./masonry.js";
import * as vscroll from "./plugins/vscroll.js";

export function init() {
    mfp.init();
    lazyload.init();

    init_carousel();
    //masonry.init();
    vscroll.init();
    isotope.init();
    tippy.init();
    // init_galleries();
    //console.log("accordion", typeof accordion);


    jQuery(".accordion").accordion({

        header: ".accordionheader",
        heightStyle: "content",
        collapsible: true
    });




}

function init_carousel() {
    slick.init();

    // jQuery(window).resize(function () {
    //     console.log("re-init slick")
    //     jQuery(".slick-slider").removeClass("slick-initialized");
    //     slick.init()
    // });
}

// export function init_galleries() {
//     jQuery('.popup-video').magnificPopup({
//         type: 'iframe',
//         callbacks: {
//             beforeOpen: function () {
//                 // just a hack that adds mfp-anim class to markup 
//                 this.st.image.markup = this.st.image.markup.replace('mfp-content', 'mfp-video mfp-content');
//             }
//         },
//     });

//     jQuery('.popup-gallery').magnificPopup({
//         delegate: '.owl-item:not(.cloned) a, .grid-item:not(.href) a',
//         type: 'image',
//         callbacks: {
//             beforeOpen: function () {
//                 // just a hack that adds mfp-anim class to markup 
//                 this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
//                 this.st.mainClass = this.st.el.attr('data-effect');
//             }
//         },
//         tLoading: 'Loading image #%curr%...',
//         mainClass: 'mfp-img-mobile',
//         gallery: {
//             enabled: true,
//             navigateByImgClick: true,
//             preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
//         },
//         image: {
//             tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
//             titleSrc: function (item) {
//                 return item.el.attr('title') + '<small></small>';
//             }
//         }
//     });
// }